import styled from 'styled-components';

import { colorsV2 } from '../../../figma/colors-v2';
import { CONTENT_MIDDLE_MAX_WIDTH } from '../../../figma/Layout/Landing/constants';
import { deviceBreakpoints } from '../../../hooks/useDeviceQuery.hook';

const DragItem = styled.div`
  display: grid;
  position: relative;

  &.on-drag {
    border-radius: 8px;
    box-shadow: 0 16px 24px ${colorsV2.blackShadow6}, 0 2px 6px ${colorsV2.blackShadow4},
      0 0 1px ${colorsV2.blackShadow4};
  }
`;

const SeparationLine = styled.div`
  width: 100%;
  height: 12px;
  background-color: ${colorsV2.black10};
`;

const SectionTitle = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  align-items: center;
  column-gap: 12px;
`;

export const Styled = {
  SectionTitle,
  SeparationLine,
  DragItem,
};

export const SectionDivider = styled.div`
  height: 1px;
  width: 100vw;
  background-color: ${colorsV2.black20};
  @media ${deviceBreakpoints.desktop} {
    width: 1080px;
  }
  @media ${deviceBreakpoints.tablet} {
    margin-left: calc(-1 * ((100vw - ${CONTENT_MIDDLE_MAX_WIDTH.TABLET}px) / 2));
  }
  @media ${deviceBreakpoints.mobile} {
    margin-left: calc(-1 * ((100vw - ${CONTENT_MIDDLE_MAX_WIDTH.MOBILE}px) / 2));
  }
  @media ${deviceBreakpoints.lgMobile} {
    margin-left: calc(-1 * ((100vw - ${CONTENT_MIDDLE_MAX_WIDTH.LG_MOBILE}px) / 2));
  }
`;
